
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-table",
  "use": "icon-material-table-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-table\"><path d=\"M114.02-182.15v-595.7q0-28.45 19.89-48.41t48.24-19.96h595.7q28.45 0 48.41 19.96t19.96 48.41v595.7q0 28.35-19.96 48.24t-48.41 19.89h-595.7q-28.35 0-48.24-19.89t-19.89-48.24m68.13-440.96h595.7v-154.74h-595.7zm218.57 220.48h158.56v-160.48H400.72zm0 220.48h158.56v-160.48H400.72zM182.15-402.63h158.57v-160.48H182.15zm437.13 0h158.57v-160.48H619.28zM182.15-182.15h158.57v-160.48H182.15zm437.13 0h158.57v-160.48H619.28z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-table"/>
                </svg>
            );
        };

        Icon.id = "icon-material-table";

        export default Icon;
    